import axios from "axios";
import { API_URL } from "./ServiceAPI";

export const ReportAPI = {
  getReports: () => {
    return axios.get(`${API_URL}/Report/getReports`);
  },

  getHlsVideo: (id) => {
    return axios.get(`${API_URL}/Report/getVideo/${id}`);
  },

  getPreviewVideoUrl: (id) => {
    return axios.get(`${API_URL}/Report/getPreviewVideoUrl/${id}`);
  },

  getReportFile: (report_data_id, fileType) => {
    return axios({
      url: `${API_URL}/Report/getReportFiles/${report_data_id}/${fileType}`,
      method: 'GET',
      responseType: 'blob',
    });
  },

  getVideoDownloadLink: (report_id, setVideoReportProgress) => {
    return axios.get(`${API_URL}/Report/getDownloadVideoLink/${report_id}`, {
      responseType: 'blob',
      onDownloadProgress: (event) => {
        if (setVideoReportProgress && event.total) {
          const percentCompleted = Math.round((event.loaded * 100) / event.total);
          setVideoReportProgress(percentCompleted);
        }
      }
    });
  }
};